import { render, staticRenderFns } from "./DevicesMockup.vue?vue&type=template&id=5af89220&scoped=true"
import script from "./DevicesMockup.vue?vue&type=script&lang=js"
export * from "./DevicesMockup.vue?vue&type=script&lang=js"
import style0 from "./DevicesMockup.vue?vue&type=style&index=0&id=5af89220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af89220",
  null
  
)

export default component.exports